var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopoverTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "butt",
    strokeLinejoin: "butt",
    strokeWidth: 1,
    points: "0,10 10,0 20,10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoverTriangle);
export default __webpack_public_path__ + "static/media/popover-triangle.2adab3423ceb8d0039823c300c18f721.svg";
export { ForwardRef as ReactComponent };